import React, { FC, useEffect, useState } from 'react';
import { ActionButtons } from 'components';
import { useCompanyDashboardContext } from 'dashboard409a/context/CompanyDashboardContext/CompanyDashboardContext';
import { useFindSlug } from 'dashboard409a/utilities';
import { Container, NavChildren, NavigationPaper, StyledTab, StyledTabs, TabsContainer } from './styles';
import { INavigation } from './types';

const Navigation: FC<INavigation> = props => {
  const { items } = props;
  const { pageActions } = useCompanyDashboardContext();

  const [selectedTab, setSelectedTab] = useState(0);

  const currentSlug = useFindSlug();

  useEffect(() => {
    const slugIndex = items.findIndex(item => item.id === currentSlug);

    setSelectedTab(slugIndex >= 0 ? slugIndex : 0);
  }, [currentSlug, items]);

  const handleChange = (_event: React.SyntheticEvent, selected: number) => {
    items[selected].handleAction();
    setSelectedTab(selected);
  };

  return (
    <NavigationPaper square elevation={0}>
      <Container container direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
        <TabsContainer>
          <StyledTabs value={selectedTab} onChange={handleChange} indicatorColor="primary" scrollButtons="auto">
            {items.map((tabItem, tabIndex) => (
              <StyledTab disabled={tabItem?.disabled ?? false} key={`tab-${tabItem.id}`} label={tabItem.title} />
            ))}
          </StyledTabs>
        </TabsContainer>
        <NavChildren>
          {pageActions && <ActionButtons />}
        </NavChildren>
      </Container>
    </NavigationPaper>
  );
};

export default Navigation;
